<template>
<!-- 禅道8372 -->
  <div></div>
</template>
<script>
import * as requiredUrls from "../../../../utils/appointment.url";
export default {
  name: "guide",
  methods: {
    // 根据大厅主键以及事项编码获取业务相关信息
    getConfig(hallSeq, itemCode) {
      requiredUrls
        .getMsgByHallAndItem(
          {
            hallSeq,
            itemCode,
          },
          "get"
        )
        .then((res) => {
          if (+res.status === 200) {
            console.log(res.data, "res.data");
            this.handleGuide(res.data);
          } else {
            this.$message.error(res.desc);
          }
        })
        .catch((err) => {
          console.log(err, "根据大厅主键以及事项编码获取业务相关信息");
        });
    },
    handleGuide(data) {
      // 判断大厅编号对应大厅是否在网厅管理后台中有配置且配置为可预约
      if (data.hallCanReserve == 1) {
        // 判断大厅编号对应大厅是否有配置个性化跳转链接
        if (data.hallDiyLink !== "") {
          console.log(data.hallDiyLink, "data.hallDiyLink");
          window.open(data.hallDiyLink, "_self");
        } else {
          // 判断事项编码对应事项是否有绑定此大厅下的业务且业务可预约
          if (data.reserveCanReserve == 1) {
            // 判断事项绑定业务的预约平台配置是否为“自研系统”
            if (data.resPlatform == 0) {
              this.$router.push({
                path: "/reservation",
                query: {
                  areaSeq: this.$route.query.areaSeq,
                  bsSeq: data.bsSeq || "", // 业务主键
                  bsName: data.bsName || "", // 业务名称
                  hallName: data.hallName || "", // 服务大厅
                  stepsType: data.resFlow == 1 ? data.resFlow : 2, // 1 通办 2 常规
                  batOpenStatus: data.batOpenStatus || "", // 批量预约服务开关
                  ifMulPlaces: data.ifMulPlaces || "", // 批量件是否占用多个预约名额
                  maxOfHandle: data.maxOfHandle || "", // 批量件最大办理数量
                  extentedType: "",
                },
              });
            } else {
              // 判断事项绑定业务的PC端呈现方式配置是否为“隐藏入口”
              if (data.pcShow == 0) {
                this.$router.push({
                  path: "/error",
                  query: {
                    type: 2,
                  },
                });
              } else {
                console.log(data.pcShowUrl, "data.pcShowUrl");
                window.open(data.pcShowUrl, "_self");
              }
            }
          } else {
            this.$router.push({
              path: "/error",
              query: {
                type: 2,
              },
            });
          }
        }
      } else {
        this.$router.push({
          path: "/error",
          query: {
            type: 1,
          },
        });
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getConfig(to.query.hallSeq, to.query.itemCode);
    });
  },
};
</script>